import "./styles.scss";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useForm from "../../../hooks/useForm";
import { USER_POST, USER_TYPE } from "../../../API/userApi";

import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Password } from "primereact/password";
import { SideMenu } from "../../../components/SideMenu";

export function NewUser() {
  const [profiles, setProfiles] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const name = useForm();
  const email = useForm();
  const password = useForm();
  const profile = useForm();

  const token = window.localStorage.getItem("token");

  useEffect(() => {
    async function getUserType() {
      setError(null);

      const { url, options } = USER_TYPE(token);

      const typeResponse = await fetch(url, options);
      const typeJson = await typeResponse.json();

      setProfiles(typeJson.data.data);
    }

    getUserType();
  }, [token]);

  async function handleSubmit(event) {
    event.preventDefault();

    const { url, options } = USER_POST(
      {
        name: name.value,
        email: email.value,
        password: password.value,
        fk_id_type: profile.value.code,
        fk_id_client: profile.value.fk_id_client,
      },
      token
    );

    try {
      setLoading(true);

      const userResponse = await fetch(url, options);
      const userJson = await userResponse.json();

      if (userJson.message === "Formato incorreto") {
        setError("Insira uma senha com no minimo 6 caracteres.");
      }

      setLoading(false);
      navigate("/users");
    } catch {
      setError(
        "Houve um erro ao enviar os dados, contate o suporte ou tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div>
        <SideMenu />
      </div>

      <div className="container fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="header">
              <div>
                <i className="fas fa-users"></i>
                <h2>Acessos</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="formContainer">
          <h2>Cadastro de Novo Usuário</h2>
          {error ? <p className="text-danger">{error}</p> : ""}
          <form className="row" onSubmit={handleSubmit}>
            <div className="col-md-12 form-group">
              <label htmlFor="name">Nome</label>
              <InputText
                id="name"
                name="name"
                {...name}
                className="form-control"
              />
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="email">Email</label>
              <InputText
                id="email"
                type="email"
                name="email"
                {...email}
                className="form-control"
                autoComplete="off"
              />
            </div>

            <div className="col-md-6 form-group">
              <label htmlFor="password">Senha</label>
              <br />
              <Password
                inputStyle={{ width: "100%" }}
                style={{ width: "100%" }}
                id="password"
                name="password"
                placeholder="No minimo 6 caracteres"
                {...password}
                toggleMask
                feedback={false}
                autoComplete="off"
              />
            </div>

            <div className="col-md-6 form-group">
              <label htmlFor="profile">Perfil de Acesso</label>
              <br />
              <Dropdown
                style={{ width: "100%" }}
                name="profile"
                id="profile"
                {...profile}
                options={profiles}
                optionLabel="name"
              />
            </div>

            <div className="col-md-12 buttonBox">
              <Link to="/users">
                <button className="cancel">Cancelar</button>
              </Link>
              {loading ? (
                <button type="submit" disabled className="register">
                  Cadastrado...
                </button>
              ) : (
                <button type="submit" className="register">
                  Cadastrar
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
